import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyAziendeService
 * Client API per la gestione delle aziende clienti nel modulo
 * "Gestione Adempimenti Sicurezza".
 */
export default class SafetyAziendeService {
    static getAll = () => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende`;
        return ApiService.getRudeRequest(url);
    };

    static find = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/find`;
            ApiService.postRudeRequest(resolve, reject, url, params);
        });
    };

    static count = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/count`;
            ApiService.postRudeRequest(resolve, reject, url, params);
        });
    };

    static show = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/show`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static create = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/create`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static update = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/update`;
            ApiService.putRequest(resolve, reject, url, data);
        });
    };

    static delete = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/aziende/delete`;
            ApiService.delete(resolve, reject, url, { id_azienda });
        });
    };
}
